import { Outlet } from 'react-router-dom'
import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'

import { DashboardLayout } from '@components'
import { HandleDeleteTicketModalProvider, HandleTicketModalProvider } from '@contexts'

import { SupplierMenu } from './SupplierMenu'
import { DeleteTicketNotificationProvider } from '../../contexts/DeleteTicketNotificationContext'

dayjs.extend(isoWeek)

const selectOptions = [{ value: 'ticketId', label: 'Trip ID' }]

const SuppliersRouter = () => {
  return (
    <DeleteTicketNotificationProvider>
      <HandleTicketModalProvider>
        <HandleDeleteTicketModalProvider>
          <DashboardLayout menu={SupplierMenu} searchSelectOptions={selectOptions}>
            <Outlet />
          </DashboardLayout>
        </HandleDeleteTicketModalProvider>
      </HandleTicketModalProvider>
    </DeleteTicketNotificationProvider>
  )
}

export { SuppliersRouter }
